import classNames from 'classnames';
import { Component, ReactNode } from 'react';
import './react-ui-switch-button.scss';

interface Props {
  checked?: boolean;
  content?: ReactNode;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  testid?: string;
}

class SwitchButton extends Component<Props> {
  public static defaultProps = {
    disabled: false,
  };

  public static demoProps = [
    { checked: true },
    { checked: true, content: 'This one is disabled', disabled: true },
    { checked: false, content: 'This one as well', disabled: true },
    { checked: null },
  ];

  public static demoHandlers = {
    onChange: {
      handler: () => null,
      prop: 'checked',
    },
  };

  private handleChange = () => {
    const { checked, disabled, onChange } = this.props;
    if (disabled) {
      return;
    }
    if (onChange) {
      onChange(!checked);
    }
  };

  public render() {
    const { checked, content, disabled, testid } = this.props;
    const undertermined = checked == null;

    return (
      <button
        type="button"
        className={classNames({
          SwitchButton: true,
          'SwitchButton--checked': checked,
          'SwitchButton--disabled': disabled,
        })}
        onClick={this.handleChange}
        disabled={disabled}
        data-testid={testid}
      >
        <div
          className={classNames({
            SwitchButton__background: true,
            'SwitchButton__background--checked': checked,
            'SwitchButton__background--disabled': disabled,
            'SwitchButton__background--undertermined': undertermined,
          })}
        >
          <div
            className={classNames({
              SwitchButton__btn: true,
              'SwitchButton__btn--checked': checked,
              'SwitchButton__btn--disabled': disabled,
              'SwitchButton__btn--undertermined': undertermined,
            })}
          />
        </div>
        {!!content && (
          <div
            className={classNames({
              SwitchButton__Label: true,
              'SwitchButton__Label--disabled': disabled,
            })}
          >
            {content}
          </div>
        )}
      </button>
    );
  }
}

export default SwitchButton;
